import { ModelBase } from 'store/model-base';
import { ShipmentStatus } from 'my-account/constants';

export class OrderShipment extends ModelBase {
    public static storeName: string = 'orderShipment';
    public static idAttribute: string = 'trackingNumber';

    public carrier: string;
    public shipmentState: ShipmentStatus;
    public shipmentTrackingUrl: string;
    public trackingNumber: string;
    public returnLabelNumber: string;
    public returnLabelUrl: string;
    public estimatedDeliveryDate: string;
    public estimatedShipDate: string;
    public shippedDate: string;
    public deliveredDate: string;

    public get isShipped(): boolean {
        return this.shipmentState === ShipmentStatus.SHIPPED;
    }

    public get isDelivered(): boolean {
        return this.shipmentState === ShipmentStatus.DELIVERED;
    }

    public get isForReturnLabel(): boolean {
        return Boolean(this.returnLabelNumber && this.returnLabelUrl);
    }
}
